// extracted by mini-css-extract-plugin
module.exports = {"icon-currency-mini":"styles_icon-currency-mini___VRFP","icon-title-lg":"styles_icon-title-lg__9STp3"};